import { adminPermissions } from './adminPermissions';
import { priceObserverPermissions } from './priceObserverPermissions';
import { superuserPermissions } from './superUserPermissions';

export const permissions = [
  ...adminPermissions,
  ...priceObserverPermissions,
  ...superuserPermissions,
];
